export interface CountryCode {
  code: string;
  dialCode: string;
  flag: string;
  name: string;
}

// France en premier, puis liste complète (ordre alphabétique par nom FR)
export const countryCodes: CountryCode[] = [
  { code: 'FR', dialCode: '+33', flag: 'FR', name: 'France' },
  { code: 'SN', dialCode: '+221', flag: 'SN', name: 'Sénégal' },
  { code: 'AF', dialCode: '+93', flag: 'AF', name: 'Afghanistan' },
  { code: 'ZA', dialCode: '+27', flag: 'ZA', name: 'Afrique du Sud' },
  { code: 'AL', dialCode: '+355', flag: 'AL', name: 'Albanie' },
  { code: 'DZ', dialCode: '+213', flag: 'DZ', name: 'Algérie' },
  { code: 'DE', dialCode: '+49', flag: 'DE', name: 'Allemagne' },
  { code: 'AD', dialCode: '+376', flag: 'AD', name: 'Andorre' },
  { code: 'AO', dialCode: '+244', flag: 'AO', name: 'Angola' },
  { code: 'AG', dialCode: '+1268', flag: 'AG', name: 'Antigua-et-Barbuda' },
  { code: 'SA', dialCode: '+966', flag: 'SA', name: 'Arabie saoudite' },
  { code: 'AR', dialCode: '+54', flag: 'AR', name: 'Argentine' },
  { code: 'AM', dialCode: '+374', flag: 'AM', name: 'Arménie' },
  { code: 'AU', dialCode: '+61', flag: 'AU', name: 'Australie' },
  { code: 'AT', dialCode: '+43', flag: 'AT', name: 'Autriche' },
  { code: 'AZ', dialCode: '+994', flag: 'AZ', name: 'Azerbaïdjan' },
  { code: 'BS', dialCode: '+1242', flag: 'BS', name: 'Bahamas' },
  { code: 'BH', dialCode: '+973', flag: 'BH', name: 'Bahreïn' },
  { code: 'BD', dialCode: '+880', flag: 'BD', name: 'Bangladesh' },
  { code: 'BB', dialCode: '+1246', flag: 'BB', name: 'Barbade' },
  { code: 'BE', dialCode: '+32', flag: 'BE', name: 'Belgique' },
  { code: 'BZ', dialCode: '+501', flag: 'BZ', name: 'Belize' },
  { code: 'BJ', dialCode: '+229', flag: 'BJ', name: 'Bénin' },
  { code: 'BT', dialCode: '+975', flag: 'BT', name: 'Bhoutan' },
  { code: 'BY', dialCode: '+375', flag: 'BY', name: 'Biélorussie' },
  { code: 'MM', dialCode: '+95', flag: 'MM', name: 'Birmanie' },
  { code: 'BO', dialCode: '+591', flag: 'BO', name: 'Bolivie' },
  { code: 'BA', dialCode: '+387', flag: 'BA', name: 'Bosnie-Herzégovine' },
  { code: 'BW', dialCode: '+267', flag: 'BW', name: 'Botswana' },
  { code: 'BR', dialCode: '+55', flag: 'BR', name: 'Brésil' },
  { code: 'BN', dialCode: '+673', flag: 'BN', name: 'Brunei' },
  { code: 'BG', dialCode: '+359', flag: 'BG', name: 'Bulgarie' },
  { code: 'BF', dialCode: '+226', flag: 'BF', name: 'Burkina Faso' },
  { code: 'BI', dialCode: '+257', flag: 'BI', name: 'Burundi' },
  { code: 'KH', dialCode: '+855', flag: 'KH', name: 'Cambodge' },
  { code: 'CM', dialCode: '+237', flag: 'CM', name: 'Cameroun' },
  { code: 'CA', dialCode: '+1', flag: 'CA', name: 'Canada' },
  { code: 'CV', dialCode: '+238', flag: 'CV', name: 'Cap-Vert' },
  { code: 'CF', dialCode: '+236', flag: 'CF', name: 'République centrafricaine' },
  { code: 'CL', dialCode: '+56', flag: 'CL', name: 'Chili' },
  { code: 'CN', dialCode: '+86', flag: 'CN', name: 'Chine' },
  { code: 'CY', dialCode: '+357', flag: 'CY', name: 'Chypre' },
  { code: 'CO', dialCode: '+57', flag: 'CO', name: 'Colombie' },
  { code: 'KM', dialCode: '+269', flag: 'KM', name: 'Comores' },
  { code: 'CG', dialCode: '+242', flag: 'CG', name: 'Congo' },
  { code: 'CD', dialCode: '+243', flag: 'CD', name: 'République démocratique du Congo' },
  { code: 'KR', dialCode: '+82', flag: 'KR', name: 'Corée du Sud' },
  { code: 'KP', dialCode: '+850', flag: 'KP', name: 'Corée du Nord' },
  { code: 'CR', dialCode: '+506', flag: 'CR', name: 'Costa Rica' },
  { code: 'CI', dialCode: '+225', flag: 'CI', name: 'Côte d\'Ivoire' },
  { code: 'HR', dialCode: '+385', flag: 'HR', name: 'Croatie' },
  { code: 'CU', dialCode: '+53', flag: 'CU', name: 'Cuba' },
  { code: 'DK', dialCode: '+45', flag: 'DK', name: 'Danemark' },
  { code: 'DJ', dialCode: '+253', flag: 'DJ', name: 'Djibouti' },
  { code: 'DM', dialCode: '+1767', flag: 'DM', name: 'Dominique' },
  { code: 'EG', dialCode: '+20', flag: 'EG', name: 'Égypte' },
  { code: 'AE', dialCode: '+971', flag: 'AE', name: 'Émirats arabes unis' },
  { code: 'EC', dialCode: '+593', flag: 'EC', name: 'Équateur' },
  { code: 'ER', dialCode: '+291', flag: 'ER', name: 'Érythrée' },
  { code: 'ES', dialCode: '+34', flag: 'ES', name: 'Espagne' },
  { code: 'EE', dialCode: '+372', flag: 'EE', name: 'Estonie' },
  { code: 'US', dialCode: '+1', flag: 'US', name: 'États-Unis' },
  { code: 'ET', dialCode: '+251', flag: 'ET', name: 'Éthiopie' },
  { code: 'FJ', dialCode: '+679', flag: 'FJ', name: 'Fidji' },
  { code: 'FI', dialCode: '+358', flag: 'FI', name: 'Finlande' },
  { code: 'GA', dialCode: '+241', flag: 'GA', name: 'Gabon' },
  { code: 'GM', dialCode: '+220', flag: 'GM', name: 'Gambie' },
  { code: 'GE', dialCode: '+995', flag: 'GE', name: 'Géorgie' },
  { code: 'GH', dialCode: '+233', flag: 'GH', name: 'Ghana' },
  { code: 'GR', dialCode: '+30', flag: 'GR', name: 'Grèce' },
  { code: 'GD', dialCode: '+1473', flag: 'GD', name: 'Grenade' },
  { code: 'GT', dialCode: '+502', flag: 'GT', name: 'Guatemala' },
  { code: 'GN', dialCode: '+224', flag: 'GN', name: 'Guinée' },
  { code: 'GW', dialCode: '+245', flag: 'GW', name: 'Guinée-Bissau' },
  { code: 'GQ', dialCode: '+240', flag: 'GQ', name: 'Guinée équatoriale' },
  { code: 'GY', dialCode: '+592', flag: 'GY', name: 'Guyana' },
  { code: 'HT', dialCode: '+509', flag: 'HT', name: 'Haïti' },
  { code: 'HN', dialCode: '+504', flag: 'HN', name: 'Honduras' },
  { code: 'HU', dialCode: '+36', flag: 'HU', name: 'Hongrie' },
  { code: 'IN', dialCode: '+91', flag: 'IN', name: 'Inde' },
  { code: 'ID', dialCode: '+62', flag: 'ID', name: 'Indonésie' },
  { code: 'IQ', dialCode: '+964', flag: 'IQ', name: 'Irak' },
  { code: 'IR', dialCode: '+98', flag: 'IR', name: 'Iran' },
  { code: 'IE', dialCode: '+353', flag: 'IE', name: 'Irlande' },
  { code: 'IS', dialCode: '+354', flag: 'IS', name: 'Islande' },
  { code: 'IL', dialCode: '+972', flag: 'IL', name: 'Israël' },
  { code: 'IT', dialCode: '+39', flag: 'IT', name: 'Italie' },
  { code: 'JM', dialCode: '+1876', flag: 'JM', name: 'Jamaïque' },
  { code: 'JP', dialCode: '+81', flag: 'JP', name: 'Japon' },
  { code: 'JO', dialCode: '+962', flag: 'JO', name: 'Jordanie' },
  { code: 'KZ', dialCode: '+7', flag: 'KZ', name: 'Kazakhstan' },
  { code: 'KE', dialCode: '+254', flag: 'KE', name: 'Kenya' },
  { code: 'KG', dialCode: '+996', flag: 'KG', name: 'Kirghizistan' },
  { code: 'KI', dialCode: '+686', flag: 'KI', name: 'Kiribati' },
  { code: 'KW', dialCode: '+965', flag: 'KW', name: 'Koweït' },
  { code: 'LA', dialCode: '+856', flag: 'LA', name: 'Laos' },
  { code: 'LS', dialCode: '+266', flag: 'LS', name: 'Lesotho' },
  { code: 'LV', dialCode: '+371', flag: 'LV', name: 'Lettonie' },
  { code: 'LB', dialCode: '+961', flag: 'LB', name: 'Liban' },
  { code: 'LR', dialCode: '+231', flag: 'LR', name: 'Liberia' },
  { code: 'LY', dialCode: '+218', flag: 'LY', name: 'Libye' },
  { code: 'LI', dialCode: '+423', flag: 'LI', name: 'Liechtenstein' },
  { code: 'LT', dialCode: '+370', flag: 'LT', name: 'Lituanie' },
  { code: 'LU', dialCode: '+352', flag: 'LU', name: 'Luxembourg' },
  { code: 'MK', dialCode: '+389', flag: 'MK', name: 'Macédoine du Nord' },
  { code: 'MG', dialCode: '+261', flag: 'MG', name: 'Madagascar' },
  { code: 'MY', dialCode: '+60', flag: 'MY', name: 'Malaisie' },
  { code: 'MW', dialCode: '+265', flag: 'MW', name: 'Malawi' },
  { code: 'MV', dialCode: '+960', flag: 'MV', name: 'Maldives' },
  { code: 'ML', dialCode: '+223', flag: 'ML', name: 'Mali' },
  { code: 'MT', dialCode: '+356', flag: 'MT', name: 'Malte' },
  { code: 'MA', dialCode: '+212', flag: 'MA', name: 'Maroc' },
  { code: 'MH', dialCode: '+692', flag: 'MH', name: 'Îles Marshall' },
  { code: 'MU', dialCode: '+230', flag: 'MU', name: 'Maurice' },
  { code: 'MR', dialCode: '+222', flag: 'MR', name: 'Mauritanie' },
  { code: 'MX', dialCode: '+52', flag: 'MX', name: 'Mexique' },
  { code: 'FM', dialCode: '+691', flag: 'FM', name: 'Micronésie' },
  { code: 'MD', dialCode: '+373', flag: 'MD', name: 'Moldavie' },
  { code: 'MC', dialCode: '+377', flag: 'MC', name: 'Monaco' },
  { code: 'MN', dialCode: '+976', flag: 'MN', name: 'Mongolie' },
  { code: 'ME', dialCode: '+382', flag: 'ME', name: 'Monténégro' },
  { code: 'MZ', dialCode: '+258', flag: 'MZ', name: 'Mozambique' },
  { code: 'NA', dialCode: '+264', flag: 'NA', name: 'Namibie' },
  { code: 'NR', dialCode: '+674', flag: 'NR', name: 'Nauru' },
  { code: 'NP', dialCode: '+977', flag: 'NP', name: 'Népal' },
  { code: 'NI', dialCode: '+505', flag: 'NI', name: 'Nicaragua' },
  { code: 'NE', dialCode: '+227', flag: 'NE', name: 'Niger' },
  { code: 'NG', dialCode: '+234', flag: 'NG', name: 'Nigeria' },
  { code: 'NO', dialCode: '+47', flag: 'NO', name: 'Norvège' },
  { code: 'NZ', dialCode: '+64', flag: 'NZ', name: 'Nouvelle-Zélande' },
  { code: 'OM', dialCode: '+968', flag: 'OM', name: 'Oman' },
  { code: 'UG', dialCode: '+256', flag: 'UG', name: 'Ouganda' },
  { code: 'UZ', dialCode: '+998', flag: 'UZ', name: 'Ouzbékistan' },
  { code: 'PK', dialCode: '+92', flag: 'PK', name: 'Pakistan' },
  { code: 'PW', dialCode: '+680', flag: 'PW', name: 'Palaos' },
  { code: 'PA', dialCode: '+507', flag: 'PA', name: 'Panama' },
  { code: 'PG', dialCode: '+675', flag: 'PG', name: 'Papouasie-Nouvelle-Guinée' },
  { code: 'PY', dialCode: '+595', flag: 'PY', name: 'Paraguay' },
  { code: 'NL', dialCode: '+31', flag: 'NL', name: 'Pays-Bas' },
  { code: 'PE', dialCode: '+51', flag: 'PE', name: 'Pérou' },
  { code: 'PH', dialCode: '+63', flag: 'PH', name: 'Philippines' },
  { code: 'PL', dialCode: '+48', flag: 'PL', name: 'Pologne' },
  { code: 'PT', dialCode: '+351', flag: 'PT', name: 'Portugal' },
  { code: 'QA', dialCode: '+974', flag: 'QA', name: 'Qatar' },
  { code: 'RO', dialCode: '+40', flag: 'RO', name: 'Roumanie' },
  { code: 'GB', dialCode: '+44', flag: 'GB', name: 'Royaume-Uni' },
  { code: 'RU', dialCode: '+7', flag: 'RU', name: 'Russie' },
  { code: 'RW', dialCode: '+250', flag: 'RW', name: 'Rwanda' },
  { code: 'KN', dialCode: '+1869', flag: 'KN', name: 'Saint-Kitts-et-Nevis' },
  { code: 'SM', dialCode: '+378', flag: 'SM', name: 'Saint-Marin' },
  { code: 'VC', dialCode: '+1784', flag: 'VC', name: 'Saint-Vincent-et-les-Grenadines' },
  { code: 'LC', dialCode: '+1758', flag: 'LC', name: 'Sainte-Lucie' },
  { code: 'SV', dialCode: '+503', flag: 'SV', name: 'Salvador' },
  { code: 'WS', dialCode: '+685', flag: 'WS', name: 'Samoa' },
  { code: 'ST', dialCode: '+239', flag: 'ST', name: 'Sao Tomé-et-Príncipe' },
  { code: 'RS', dialCode: '+381', flag: 'RS', name: 'Serbie' },
  { code: 'SC', dialCode: '+248', flag: 'SC', name: 'Seychelles' },
  { code: 'SL', dialCode: '+232', flag: 'SL', name: 'Sierra Leone' },
  { code: 'SG', dialCode: '+65', flag: 'SG', name: 'Singapour' },
  { code: 'SK', dialCode: '+421', flag: 'SK', name: 'Slovaquie' },
  { code: 'SI', dialCode: '+386', flag: 'SI', name: 'Slovénie' },
  { code: 'SO', dialCode: '+252', flag: 'SO', name: 'Somalie' },
  { code: 'SD', dialCode: '+249', flag: 'SD', name: 'Soudan' },
  { code: 'SS', dialCode: '+211', flag: 'SS', name: 'Soudan du Sud' },
  { code: 'LK', dialCode: '+94', flag: 'LK', name: 'Sri Lanka' },
  { code: 'SE', dialCode: '+46', flag: 'SE', name: 'Suède' },
  { code: 'CH', dialCode: '+41', flag: 'CH', name: 'Suisse' },
  { code: 'SR', dialCode: '+597', flag: 'SR', name: 'Suriname' },
  { code: 'SZ', dialCode: '+268', flag: 'SZ', name: 'Eswatini' },
  { code: 'SY', dialCode: '+963', flag: 'SY', name: 'Syrie' },
  { code: 'TJ', dialCode: '+992', flag: 'TJ', name: 'Tadjikistan' },
  { code: 'TZ', dialCode: '+255', flag: 'TZ', name: 'Tanzanie' },
  { code: 'TD', dialCode: '+235', flag: 'TD', name: 'Tchad' },
  { code: 'CZ', dialCode: '+420', flag: 'CZ', name: 'Tchéquie' },
  { code: 'TH', dialCode: '+66', flag: 'TH', name: 'Thaïlande' },
  { code: 'TL', dialCode: '+670', flag: 'TL', name: 'Timor oriental' },
  { code: 'TG', dialCode: '+228', flag: 'TG', name: 'Togo' },
  { code: 'TO', dialCode: '+676', flag: 'TO', name: 'Tonga' },
  { code: 'TT', dialCode: '+1868', flag: 'TT', name: 'Trinité-et-Tobago' },
  { code: 'TN', dialCode: '+216', flag: 'TN', name: 'Tunisie' },
  { code: 'TM', dialCode: '+993', flag: 'TM', name: 'Turkménistan' },
  { code: 'TR', dialCode: '+90', flag: 'TR', name: 'Turquie' },
  { code: 'TV', dialCode: '+688', flag: 'TV', name: 'Tuvalu' },
  { code: 'UA', dialCode: '+380', flag: 'UA', name: 'Ukraine' },
  { code: 'UY', dialCode: '+598', flag: 'UY', name: 'Uruguay' },
  { code: 'VU', dialCode: '+678', flag: 'VU', name: 'Vanuatu' },
  { code: 'VA', dialCode: '+379', flag: 'VA', name: 'Vatican' },
  { code: 'VE', dialCode: '+58', flag: 'VE', name: 'Venezuela' },
  { code: 'VN', dialCode: '+84', flag: 'VN', name: 'Viêt Nam' },
  { code: 'YE', dialCode: '+967', flag: 'YE', name: 'Yémen' },
  { code: 'ZM', dialCode: '+260', flag: 'ZM', name: 'Zambie' },
  { code: 'ZW', dialCode: '+263', flag: 'ZW', name: 'Zimbabwe' },
];

export const defaultCountry = countryCodes[0]; // France

export function getPhonePlaceholder(countryCode: string): string {
  const placeholders: Record<string, string> = {
    FR: '6 12 34 56 78',
    SN: '77 123 45 67',
    US: '(555) 123-4567',
    GB: '7700 900123',
    CI: '07 12 34 56 78',
    CM: '6 12 34 56 78',
    ML: '76 12 34 56',
    BF: '70 12 34 56',
    DZ: '5 12 34 56 78',
    MA: '6 12 34 56 78',
    TN: '9 12 34 56 78',
    DE: '151 2345678',
    BE: '470 12 34 56',
    CH: '78 123 45 67',
    ES: '612 34 56 78',
    IT: '312 345 6789',
    CA: '(555) 123-4567',
  };
  return placeholders[countryCode] || '123 456 789';
}

/** Parse full international phone (e.g. +221771234567) into country + local number */
export function parsePhone(fullPhone: string | null): { country: CountryCode; local: string } {
  if (!fullPhone || !fullPhone.startsWith('+')) {
    return { country: defaultCountry, local: fullPhone?.replace(/\D/g, '') ?? '' };
  }
  const sorted = [...countryCodes].sort((a, b) => b.dialCode.length - a.dialCode.length);
  for (const c of sorted) {
    if (fullPhone.startsWith(c.dialCode)) {
      const local = fullPhone.slice(c.dialCode.length).replace(/\D/g, '');
      return { country: c, local };
    }
  }
  return { country: defaultCountry, local: fullPhone.replace(/\D/g, '') };
}
